// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header.floating:hover h1.logo a[data-v-3b1590f6],header h1.logo a[data-v-3b1590f6]{margin:0 -10px;padding:0 10px;white-space:nowrap}.cls-1[data-v-3b1590f6]{fill:#5e2bb8}.cls-2[data-v-3b1590f6]{fill:#07d0da}", ""]);
// Exports
module.exports = exports;
